import { AlertOctagon, AlertTriangle, Info, CheckCircle } from 'lucide-react';

interface AlertDetail {
  id: string | null;
  type: string | null;
  severity: string;
  status: string | null;
  title: string;
  message: string;
  dueDate: string | null;
}

interface Props {
  alerts: AlertDetail[];
}

/**
 * Card lateral do detalhe do ativo. Mescla alertas persistidos (SPEC 04) +
 * transient hardcoded (RETIRED). Ordem por severity vem do backend
 * (`buildAlerts` já retorna ordenado).
 *
 * D4 da SPEC 03 fechado: severity mapeia pra ícone + cor.
 */
export function CardAlertas({ alerts }: Props) {
  if (alerts.length === 0) {
    return (
      <p className="flex items-center gap-2 text-sm text-gray-500">
        <CheckCircle className="h-4 w-4 text-green-500" /> Nenhuma pendência.
      </p>
    );
  }
  return (
    <ul className="space-y-2">
      {alerts.map((a, i) => {
        const Icon =
          a.severity === 'critical' ? AlertOctagon :
          a.severity === 'warning' ? AlertTriangle :
          Info;
        const color =
          a.severity === 'critical' ? 'text-red-700 bg-red-50 border-red-200' :
          a.severity === 'warning' ? 'text-yellow-800 bg-yellow-50 border-yellow-200' :
          'text-blue-800 bg-blue-50 border-blue-200';
        return (
          <li key={a.id ?? `t${i}`} className={`rounded-md border p-2 text-xs ${color}`}>
            <div className="flex items-start gap-2">
              <Icon className="h-4 w-4 flex-shrink-0 mt-0.5" />
              <div className="min-w-0">
                <p className="font-medium">{a.title}</p>
                <p className="mt-0.5">{a.message}</p>
                {a.status === 'acknowledged' && (
                  <p className="mt-0.5 text-[10px] uppercase tracking-wide opacity-70">Reconhecido</p>
                )}
              </div>
            </div>
          </li>
        );
      })}
    </ul>
  );
}
